import React, {useEffect} from "react";
import {AEInput, Card, CardBody} from "../../../../../_metronic/_partials/controls";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {useMetadata} from "../../../../../_emywork/AEPagination";
import {actionTypes} from "../../_redux/slice";
import {fetchEntities} from "../../_redux/actions";
import {useIntl} from "react-intl";
import {AEButton} from "../../../../../_emywork/components/buttons";
import {useFormik} from "formik";
import KTAppChat from "../../../../../_metronic/_assets/js/components/chat";
import {Chat} from "./Chat";
import {EntityCard} from "../../../Users/componants/EntityCard";
import { Route, Switch} from "react-router-dom";
import {ModuleProvider, useModuleContext} from "../../ModuleContext";

export const List = (props)=>(
  <ModuleProvider>
    <ListContent {...props} />
  </ModuleProvider>
)

function ListContent() {
  const dispatch = useDispatch();
  const {formatMessage} = useIntl();
  const {openChat} = useModuleContext();
  const { authUser } = useSelector( ({auth}) => ({ authUser:auth.user }), shallowEqual );

  const { entities, meta, isLoading } = useSelector(
    state => {
      return state.chat_rooms[actionTypes.List]
    }
    , shallowEqual )
  const metadata = useMetadata(meta);
  const { page, perPage, sortAsc, filters, sortField, select, setPerPage, setFilters, total } = metadata;

  const formik = useFormik({
    initialValues: filters,
    onSubmit: (values)=>{
      const { search } = values;
      setFilters(values)
    }
  });
  //
  const getEntities = () => {
    dispatch(fetchEntities(metadata.toAEMetadata())).then(r=>{
      KTAppChat.init(-10)
    });
  }

  useEffect(() => {
    getEntities()
  }, [dispatch, page, perPage, filters, select, sortField, sortAsc]);


  useEffect(() => {
    formik.handleSubmit()
  }, [formik.values.search]);


  return (
    <>
      {/*<div className={'d-flex flex-row'} id="kt_chat_aside">*/}
      <div className={'row'} id="kt_chat_aside">
        {/*<div className={'flex-row-auto -offcanvas-mobile w-350px w-xl-400px -offcanvas-mobile-on'} id="kt_chat_aside">*/}
        <div className={'col-md-5'} id="kt_chat_aside">
          <Card className={'mb-0'}>
            <CardBody >
              <AEInput
                borderless
                validation={false}
                withFeedbackLabel={false}
                className={"form-control-solid"}
                field={formik.getFieldProps('search')}
                form={formik}
                name={"search"}
                label={"SEARCH"}
              />

              {/*<div className="mt-7 scroll scroll-pull">*/}
              <div
                className="mt-7 scroll scroll-pull"
                // style={{maxHeight: 400}}
              >
                {/* user */}
                {
                  entities
                    .filter(user=>user.id !== authUser.id)
                    .map(user=>(
                      <EntityCard
                        key={user.id}
                        entity={user}
                        size={'xs'}
                        className={'my-0 mb-3 -w-100'}
                        chatAction
                      />
                    ))
                }

                {
                  total > perPage &&
                  <AEButton
                    variant={'link-primary'}
                    block
                    onClick={()=>{
                      setPerPage(perPage+10)
                    }}
                  >
                    {formatMessage({id:'LOAD_MORE'})}
                  </AEButton>
                }

              </div>

              <div className={'text-center pt-2'}>
                {
                  formatMessage(
                    {id:"METADATA.PAGINATION.DISPLAY_OF"},
                    {display: Math.min(perPage, total), total:total}
                  )
                }
              </div>
            </CardBody>
          </Card>
        </div>
        {/*<div className="offcanvas-mobile-overlay" />*/}
        {/*<div className={'flex-row-fluid ml-lg-8'} id={'kt_chat_content'}>*/}
        {/*<div className={'col-lg-7 ml-lg-8'} id={'kt_chat_content'}>*/}
        <div className={'col-md-7'} id={'kt_chat_content'}>
          <Switch>
            <Route path={`/chat_rooms/:username`} component={Chat}/>
          </Switch>


        </div>
      </div>

    </>
  );
}
